// extracted by mini-css-extract-plugin
export default {"QuickResponseButton":"QuickResponse_QuickResponseButton__421JJ"};